import { render, staticRenderFns } from "./recommend.vue?vue&type=template&id=65db1f20"
import script from "./recommend.vue?vue&type=script&lang=js"
export * from "./recommend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports